<template>
  <div class="container py-3">
    <h3 class="mt-3">即將到來的線上課</h3>
    <div class="list-group position-relative mb-5 mt-4" v-if="upcomingPost.length > 0">
      <loading :active.sync="isLoading.upcomingCourse" :is-full-page="false"></loading>
      <post-online v-for="post in upcomingPost.slice(0, 2)"
        :key="'upcoming' + post.id" :url="'/course/' + post.courseID +
          '/chapter/' + post.chapterID + '/post/' + post.path_var"
        :loading="isLoading.upcomingCourse" :data="post"></post-online>
    </div>
    <post-loading v-else
      :loading="isLoading.start"
      :has-content="isLoading.upcomingCourse"
      :num="2" no-data="今日沒有線上課哦">
    </post-loading>
    <h3 class="mt-3">最新公告</h3>
    <div class="mt-4 mb-5" v-if="allAnnouncement.length > 0">
      <div class="list-group position-relative">
        <loading :active.sync="isLoading.newestCourse" :is-full-page="false"></loading>
        <post-has-tag v-for="post in allAnnouncement.slice(0, 3)"
          :key="'new' + post.id"
          :url="'/' + post.courseID + '/chapter/' + post.chapterID + '/post/' + post.path_var"
          :data="post" :loading="isLoading.newestCourse"
          :tag="post.chapterName"
          ga-category="Dashboard" ga-action="Click Announcement">
        </post-has-tag>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <a class="btn btn-outline-primary btn-md-down-block"
          @click.prevent="gaTrackLink('Dashboard', 'Click School Announcement Btn',
            '學院公告', '/school')" href="#">更多學院公告
        </a>
        <a class="btn btn-outline-primary ml-2 btn-md-down-block" href="#"
          @click.prevent="gaTrackLink('Dashboard', 'Click Club Announcement  Btn',
            '社團公告', '/community')">
          更多社團公告
        </a>
      </div>
    </div>
    <post-loading v-else
      :loading="isLoading.start"
      :has-content="isLoading.newestCourse" :num="3" no-data="目前沒有最新公告哦">
    </post-loading>
    <h3 class="mt-3">我的課程進度</h3>
    <div class="row mt-4 mb-5" v-if="courseList.length > 0">
      <loading :active.sync="isLoading.myCourse" :is-full-page="false"></loading>
      <div class="col-lg-4 col-md-6 mt-md-0 mt-4 mb-3"
        v-for="course in courseList" :key="course.id">
        <div class="card border-0 overflow-hidden h-100">
          <a :href="'course/' + course.course.path_var" class="text-decoration-none">
            <img :src="course.course.avatar" class="card-img-top" alt="...">
            <div class="card-body border-left border-right">
              <h5 class="card-title">{{ course.course.name }}</h5>
              <div class="d-flex align-items-center" v-if="!isLoading.completedPercent">
                <span class="text-primary text-nowrap mr-2">
                  {{ eachPostCountComplete[course.course.path_var] }} %
                </span>
                <progress :value="eachPostCountComplete[course.course.path_var]"
                  class="one-color-progress" style="top: 100%; cursor: pointer;" max="100">
                </progress>
              </div>
            </div>
          </a>
          <div class="card-footer border-0 p-0 mt-auto">
            <a :href="'course/' + course.course.path_var"
              class="btn btn-primary btn-block rounded-0 custom-padding">繼續上課
              <span class="material-icons align-bottom"> arrow_forward </span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-5" v-else>
      <div class="upcoming-post list-group-item
        py-3 px-4 my-2 border rounded-lg align-items-center d-flex"
        style="min-height: 92px" :style="{'--bgColor': '#3D5AFE'}">
        <p class="h5 text-muted mb-0">目前沒有已加入的課程</p>
      </div>
    </div>
    <h3 class="mt-3">最新上架單元</h3>
    <div class="list-group position-relative mt-4 mb-5" v-if="newestPost.length > 0">
      <loading :active.sync="isLoading.newestCourse" :is-full-page="false"></loading>
      <a v-for="(post, index) in newestPost.slice(0, 3)"
        :key="'newPost' + post.id"
        :href="'/course/' + post.courseID + '/chapter/' + post.chapterID + '/post/' + post.path_var"
        class="upcoming-post list-group-item list-group-item-action
          py-3 px-4 my-2 border border-left-0 rounded-lg
          justify-content-between d-flex align-items-start"
        style="min-height: 80px" :style="{'--bgColor': newestPostColor[index%3]}">
        <div v-show="!isLoading.newestCourse" class="d-flex flex-column">
          <h5 class="font-weight-normal title-font-size"> {{ post.name }} </h5>
          <p class="text-muted mb-0 mt-auto">
            <small>{{ dateFormatYMD(post.opened_at.datetime) }}</small>
          </p>
        </div>
        <span
          class="px-md-5 px-4 py-2 rounded-lg text-nowrap tag-font-size"
          :style="{'background-color': changeOpacity(newestPostColor[index%3], 0.12)}"
        >{{ post.courseName }}</span>
      </a>
    </div>
    <post-loading v-else :loading="isLoading.start" :num="3" no-data="沒有最新上架的單元哦"></post-loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      courseList: [],
      communityList: [],
      schoolList: [],
      allPosts: [],
      eachPostCount: {},
      eachPostCountOptions: {},
      eachPostCountComplete: {},
      isLoading: {
        myCourse: false,
        upcomingCourse: false,
        newestCourse: false,
        start: true,
        completedPercent: true,
      },
      newestPostColor: ['#3D5AFE', '#000000', '#0098FF'],
    };
  },
  methods: {
    getCourse() {
      const vm = this;
      vm.isLoading.myCourse = true;
      vm.courseList = JSON.parse(window.sessionStorage.getItem('biz_thinking_courses')) || [];
      if (this.courseList.length > 0) {
        vm.isLoading.myCourse = false;
      }
      axios.get('/api/courses').then((res) => {
        vm.courseList = res.data.data;
        vm.isLoading.myCourse = false;
        vm.getAllCourseData();
        window.sessionStorage.setItem('biz_thinking_courses', JSON.stringify(vm.courseList));
      }).catch((err) => {
        flash(`頁面取得錯誤${err}`, 'danger');
        vm.isLoading.myCourse = false;
      });
    },
    getAllCourseData() {
      const vm = this;
      vm.isLoading.upcomingCourse = true;
      vm.isLoading.newestCourse = true;
      const courseAjax = [];
      this.courseList.forEach((course, index) => {
        courseAjax.push(vm.getEachCourse(course.course.path_var, index, course.course.name));
      });
      Promise.all(courseAjax).then((res) => {
        vm.isLoading.upcomingCourse = false;
        vm.isLoading.newestCourse = false;
        vm.isLoading.start = false;
        vm.getAllCourseDataOptions();
      });
    },
    getAllCourseDataOptions() {
      const vm = this;
      vm.isLoading.completedPercent = true;
      const courseOptions = [];
      this.courseList.forEach((course, index) => {
        courseOptions.push(vm.getEachCourseOptions(course.course.path_var, index));
      });
      Promise.all(courseOptions).then((res) => {
        vm.isLoading.completedPercent = false;
        vm.courseList.forEach((key) => {
          const uniqCompleted = vm.eachPostCountOptions[key.course.path_var].filter(
            (v, i, a) => a.findIndex((p) => (p.post.id === v.post.id)) === i,
          );
          vm.$set(vm.eachPostCountComplete, key.course.path_var,
            parseInt((uniqCompleted.length
            / parseInt(vm.eachPostCount[key.course.path_var].length, 10)) * 100, 10));
        });
      });
    },
    getEachCourse(course, index, courseName) {
      const vm = this;
      let defaultSecond = 250;
      return new Promise((resolve) => {
        setTimeout(() => {
          axios.get(`/api/course/${course}`).then((res) => {
            if (res.status == 200) {
              vm.eachPostCount[course] = [];
              res.data.data.chapters.forEach((chapter) => {
                chapter.posts.forEach((post) => {
                  vm.eachPostCount[course].push(post);
                  vm.allPosts.push({
                    ...post,
                    chapterName: chapter.name,
                    chapterID: chapter.path_var,
                    chapterColor: chapter.options && chapter.options.hasOwnProperty('color') ? chapter.options.color : '#E8EAF6',
                    courseID: course,
                    courseName,
                  });
                });
              });
              resolve(res);
            }
          }).catch((error) => {
          });
          if (index > 10) {
            defaultSecond = 750;
          }
        }, Math.floor(Math.random() * defaultSecond * index));
      });
    },
    getEachCourseOptions(course, index) {
      const vm = this;
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          axios.get(`/api/course/${course}/options`).then((res) => {
            if (res.status == 200) {
              vm.eachPostCountOptions[course] = [];
              res.data.data.options.completed.forEach((post) => {
                vm.eachPostCountOptions[course].push(post);
              });
              resolve(res.status);
            }
          }).catch((error) => {
          });
        }, Math.floor(Math.random() * 1200 * index));
      });
    },
    getCommunityList() {
      const vm = this;
      axios.get('/api/community').then((res) => {
        vm.communityList = res.data.data.chapters;
      }).catch((err) => {
        flash(`頁面取得錯誤${err}`, 'danger');
      });
    },
    getSchoolList() {
      const vm = this;
      axios.get('/api/school').then((res) => {
        vm.schoolList = res.data.data.chapters;
      }).catch((err) => {
        flash(`頁面取得錯誤${err}`, 'danger');
      });
    },
    changeOpacity(color, opacity) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      if (opacity) {
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
  computed: {
    allAnnouncement() { // 所有公告 -> 最新公告
      const vm = this;
      const allData = [];
      vm.communityList.forEach((chapter) => {
        chapter.posts.forEach((post) => {
          allData.push({
            ...post,
            chapterName: chapter.name,
            chapterID: chapter.path_var,
            chapterColor: chapter.options && chapter.options.hasOwnProperty('color') ? chapter.options.color : '#E8EAF6',
            courseID: 'community',
          });
        });
      });
      vm.schoolList.forEach((chapter) => {
        chapter.posts.forEach((post) => {
          allData.push({
            ...post,
            chapterName: chapter.name,
            chapterID: chapter.path_var,
            chapterColor: chapter.options && chapter.options.hasOwnProperty('color') ? chapter.options.color : '#E8EAF6',
            courseID: 'school',
          });
        });
      });
      return vm.checkItemActive(allData.slice()).sort(
        (a, b) => b.opened_at.timestamp - a.opened_at.timestamp,
      );
    },
    upcomingPost() { // 即將到來的現上課
      const vm = this;
      const now = vm.dateFormatYMD(new Date());
      const onlineCourse = vm.allPosts.filter((post) => post.webinar && post.webinar.hasOwnProperty('url') && vm.$moment(vm.dateFormatYMD(post.webinar.opened_at.datetime)).isSame(now));
      return vm.checkItemActive(onlineCourse.slice()).sort(
        (a, b) => b.opened_at.timestamp - a.opened_at.timestamp,
      );
    },
    newestPost() { // 最新上架單元
      const vm = this;
      vm.checkItemActive(JSON.parse(JSON.stringify(
        vm.allPosts.slice(),
      ))).forEach(
        (post, index) => {
          post.chapterColor = vm.newestPostColor[index % 3];
        },
      );
      return vm.checkItemActive(vm.allPosts.slice()).sort(
        (a, b) => b.opened_at.timestamp - a.opened_at.timestamp,
      );
    },
  },
  mounted() {
    this.getCourse();
    this.getSchoolList();
    this.getCommunityList();
  },
  created() {
  },
};
</script>

<style scoped>
.custom-padding {
  padding-top: 12px;
  padding-bottom: 12px;
}
.upcoming-post {
  position: relative;
  overflow: hidden;
}
.upcoming-post::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background-color: var(--bgColor);
}
.tag-font-size {
  font-size: 1rem;
}
@media (max-width: 768px) {
  .tag-font-size {
    font-size: 0.75rem
  }
}
.title-font-size {
  font-size: 1.25rem;
}
@media (max-width: 768px) {
  .title-font-size {
    font-size: 1rem;
  }
}
</style>
